import {mapState,mapMutations} from 'vuex'
import {showOverlay} from "./utils/showOverlay";

export const delItem3 = {
  mixins: [showOverlay],
  watch: {
    confirmDel3(val) {
      if (val) {
        this.deleteItems3()
      }
    }
  },
  computed: {
    ...mapState({
      confirmDel3: state => state.popups.del.confirm3
    })
  },
  methods: {
    ...mapMutations({
      showDelPopup: 'popups/del/SET_SHOW',
      setDelItems: 'popups/del/SET_ITEMS',
      setNumberDel: 'popups/del/SET_NUMBER'
    })
  }
}
